import React, { useState, useEffect } from "react";
import { PageLayout } from "../components";
import { initialise, initialiseForPhotos } from "../api/requests";
import { useNavigate } from "react-router-dom";
import { SourceSystemNames } from "../config/sourceSystemNames";

export default function Landing() {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.removeItem("state");
    sessionStorage.removeItem("appraisalSessionId");
  }, []);

  async function handleSubmit(sourceSystemName) {
    try {
      setLoading(true);
      const { data, status } = await initialise(sourceSystemName);
      if (status === 200) {
        setLoading(false);
        navigate(
          `/registration?appraisalSessionId=${data.result.appraisalSessionId}&data=${data.result.securityToken}`
        );
      }
    } catch (error) {
      setLoading(false);
    }
  }

  async function handleSubmitPhotos() {
    try {
      setLoading(true);
      const { data, status } = await initialiseForPhotos();
      if (status === 200) {
        setLoading(false);
        navigate(
          `/registration?appraisalSessionId=${data.result.appraisalSessionId}&data=${data.result.securityToken}`
        );
      }
    } catch (error) {
      setLoading(false);
    }
  }

  return (
    <PageLayout>
      <PageLayout.Header title="SMO" step={0} />
      <PageLayout.Content>
        <div
          className="ch-display--flex ch-justify-content--center ch-align-items--center ch-flex-flow--column-wrap"
          style={{ height: "100vh" }}
        >
          <button
            className="ch-btn ch-btn--secondary ch-width--6"
            onClick={() => handleSubmitPhotos()}
          >
            Start Valuation
          </button>
          {/* <button
            className="ch-btn ch-btn--secondary ch-width--6"
            onClick={() => handleSubmit()}
          >
            Start Valuation
          </button>
          <button
            className="ch-btn ch-btn--secondary ch-mt--3 ch-width--6"
            onClick={() => handleSubmit(SourceSystemNames.SalesCNP)}
          >
            CNP{" "}
          </button>
          <button
            className="ch-btn ch-btn--secondary ch-mt--3 ch-width--6"
            onClick={() => handleSubmit(SourceSystemNames.SalesOffice)}
          >
            Part-ex Branch{" "}
          </button>
          <button
            className="ch-btn ch-btn--secondary ch-mt--3 ch-width--6"
            onClick={() => handleSubmit(SourceSystemNames.SalesOfficeCustomer)}
          >
            Part-ex Customer{" "}
          </button> */}
          {loading && <p>Initialising...</p>}
        </div>
      </PageLayout.Content>
    </PageLayout>
  );
}
